import { render, staticRenderFns } from "./createRule.vue?vue&type=template&id=508ca76c&scoped=true&"
import script from "./createRule.vue?vue&type=script&lang=js&"
export * from "./createRule.vue?vue&type=script&lang=js&"
import style0 from "./createRule.vue?vue&type=style&index=0&id=508ca76c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508ca76c",
  null
  
)

export default component.exports